<div>
  <h2>{{ keyword }}<span> - Wyniki wyszukiwania</span></h2>
  <p>
    <span class="sr-only">Znaleziono</span>
    {{ amount || 0 }} wyników
  </p>
</div>
